import React, { FC } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";

interface TextAreaProps {
  id: string;
  label: string;
  type?: string;
  disabled?: boolean;
  value: any;
  formatPrice?: boolean;
  required?: boolean;
  register: any;
  errors: any;
}

const TextArea: FC<TextAreaProps> = ({
  id,
  label,
  type,
  disabled,
  formatPrice,
  required,
  register,
  errors,
}) => {
  return (
    <div className="w-full relative">
      <textarea
        id={id}
        disabled={disabled}
        {...register(id, { required })}
        placeholder=" "
        className={`
        peer
        w-full
        p-4
        pt-6 h-72
        font-semibold
        bg-white
        border-2
        rounded-md
        outline-none
        transition
        disabled:opacity-70
        disabled:cursor-not-allowed
        ${formatPrice ? "pl-9" : "pl-4"}
        ${errors[id] ? "border-red-500" : "border-neutral-300"}
        ${errors[id] ? "focus:border-red-500" : "focus:border-black"}
        `}
      />
      <label
        className={`
      absolute
      text-md
      duration-150
      transform
      -translate-y-3
      top-4
      z-10
      origin-[0]
      ${formatPrice ? "left-9" : "left-4"}
      peer-placeholder-shown:scale-100
      peer-placeholder-shown:translate-y-0
      peer-focus:scale-75
      peer-focus:-translate-y-4
      ${errors[id] ? "text-red-500" : "text-zinc-400"}
      `}
      >
        {label}
      </label>
    </div>
  );
};

export default TextArea;
